import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKasperskyComponent } from './simple-icons-kaspersky.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKasperskyComponent ],
    exports:      [ SimpleIconsKasperskyComponent ],
    bootstrap:    []
})
export class SimpleIconsKasperskyModule {}
